<template>
  <el-switch v-model="specEdit" @change="changeSwitch()" />
</template>
<script type="text/babel">
import { Switch } from 'element-ui'
import { action } from 'sky-engine/api'

import { SYSTEM } from '@/api/apiModules'
export default {
  name: 'SkySysSetting',
  inject: ['elForm'],
  components: {
    [Switch.name]: Switch
  },
  props: {},
  data() {
    return {
      specEdit: true
    }
  },
  mounted() {
    action(SYSTEM, 'spec/edit/state', {}).then(response => {
      this.specEdit = response.data.content
    })
  },
  methods: {
    changeSwitch() {
      if (this.specEdit) {
        action(SYSTEM, 'spec/edit/open', {})
          .then(response => {
            this.$store.dispatch('OpenNotification', { message: '维护模式功能开启成功', type: 'success' })
          })
          .catch(e => {
            throw e
          })
      } else {
        action(SYSTEM, 'spec/edit/close', {})
          .then(response => {
            this.$store.dispatch('OpenNotification', { message: '维护模式关闭成功', type: 'success' })
          })
          .catch(e => {
            throw e
          })
      }
    }
  }
}
</script>
